import React from 'react';

import { SubmitOrderButton } from './SubmitOrderButton';
import { TaxImpactPreviewInfoBanner } from './TaxImpactPreviewInfoBanner';

import { TaxImpactGainsAllowanceError } from '../../../../Shared/Components/tax-impact-preview/gains-allowance/TaxImpactGainsAllowanceError';
import { TaxImpactEstimateError } from '../../../../Shared/Components/tax-impact-preview/tax-impact-estimate/TaxImpactEstimateError';
import { TaxImpactGainLossError } from '../../../../Shared/Components/tax-impact-preview/tax-impact-gain-loss/TaxImpactGainLossError';
import { TaxImpactPreviewCard } from '../../../../Shared/Components/tax-impact-preview/TaxImpactPreviewCard';
import { ReviewOrderError, ReviewOrderErrorProps } from '../ReviewOrderError';

interface TaxImpactPreviewErrorProps extends ReviewOrderErrorProps {
  onSubmit: () => void;
  hasActiveQueries?: boolean;
}

export const TaxImpactPreviewError: React.FC<TaxImpactPreviewErrorProps> = ({
  onSubmit,
  hasActiveQueries = false,
  submitOrderDisplayableErrors,
  submitOrderMutationError,
  previewDisplayableErrors,
  previewMutationError,
}) => {
  return (
    <TaxImpactPreviewCard>
      <TaxImpactPreviewCard.DividedList>
        <TaxImpactEstimateError />
        <TaxImpactGainLossError />
        <TaxImpactGainsAllowanceError />
      </TaxImpactPreviewCard.DividedList>
      <TaxImpactPreviewInfoBanner />
      <SubmitOrderButton onClick={onSubmit} disabled={hasActiveQueries} />
      <ReviewOrderError
        submitOrderDisplayableErrors={submitOrderDisplayableErrors}
        submitOrderMutationError={submitOrderMutationError}
        previewDisplayableErrors={previewDisplayableErrors}
        previewMutationError={previewMutationError}
      />
    </TaxImpactPreviewCard>
  );
};
